import { pxToRem } from "@/util/common";
import { Swiper, Image } from "antd-mobile";
import { useState } from "react";
import { createUseStyles } from "react-jss";
import { BannerItem, GameItem } from "../type";
import { useGameNavigation } from "@/hooks/useGameNavigation";
import useRouter from "@/hooks/useRouter";

// const games = [
// 	require("@/assets/images/test/w700d1q75cms_1.jpg"),
// 	require("@/assets/images/test/w700d1q75cms_2.jpg"),
// 	require("@/assets/images/test/w700d1q75cms_3.jpg"),
// ];

const Banner: React.FC<{
	gameList: BannerItem[];
	onIndexChange?: ((index: number) => void) | undefined;
}> = ({ gameList, onIndexChange }) => {
	const [activeIndex, setActiveIndex] = useState(0);
	const classes = useStyles();
	const { customNavigate } = useRouter();
	const { goToPlay } = useGameNavigation();

	const handleNavigation = (game: BannerItem) => {
		const jumpType = game.jumpType;
		if ([1, 4].includes(jumpType)) {
			goToPlay({
				gameId: game.imgUrl,
				name: game.name,
				coverPic: game.img,
				gameCompany: game.vendor,
			});
		} else if (jumpType === 2) {
			customNavigate(
				"/partnergame/" + 2 + "?url=" + encodeURIComponent(game.imgUrl)
			);
		} else {
			customNavigate(game.imgUrl);
		}
	};

	return (
		<div className={classes.bannerRoot}>
			<Swiper
				slideSize={80}
				trackOffset={10}
				autoplay
				loop
				autoplayInterval={6000}
				stuckAtBoundary={false}
				// indicator={() => null}
				onIndexChange={(index) => {
					onIndexChange?.(index);
					setActiveIndex(index);
				}}
				indicatorProps={{
					color: "white",
				}}
				style={{
					"--track-padding": "0 0 16px",
				}}
			>
				{gameList.map((game, index) => (
					<Swiper.Item key={index}>
						<div
							className={`${classes.contentWrap} ${
								activeIndex === index ? "active" : ""
							}`}
							onClick={() => {
								handleNavigation(game); // 调用新的导航方法
							}}
						>
							<Image
								src={game.img}
								fit="cover"
								className={classes.content}
							/>
						</div>
					</Swiper.Item>
				))}
			</Swiper>
		</div>
	);
};

export default Banner;

const useStyles = createUseStyles({
	contentWrap: {
		padding: pxToRem(3),
		paddingTop: 0,
		height: pxToRem(180),
		transform: "scaleY(0.94)",
		"&.active": {
			boxShadow: `0px ${pxToRem(8)} ${pxToRem(24)} 0px #0C1E8540`,
			opacity: 1,
			transform: "none",
		},
	},
	bannerRoot: {},
	content: {
		width: "100%",
		height: "100%",
		border: "1px solid #384F7A",
		borderRadius: pxToRem(20),
		opacity: 0.7,
		transitionProperty: "all",
		transitionDuration: ".6s",
		transformOrigin: "bottom center",
	},
});
